const COOKIE_MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const prefix = `${name}=`;
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      return trimmed.slice(prefix.length);
    }
  }
  return null;
}

export function isNotificationDismissed(cookieKey: string): boolean {
  return readCookie(cookieKey) === '1';
}

export function dismissNotification(cookieKey: string): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = [
    `${cookieKey}=1`,
    'path=/',
    `max-age=${COOKIE_MAX_AGE_SECONDS}`,
    'SameSite=Lax',
  ].join('; ');
}
